import React from 'react';
import { WarningMessageContainer, WarningMessageIconContainer, WarningMessageText } from './style';
import { ReactComponent as WarningIcon } from "../../static/images/warningIcon.svg";
import { ReactComponent as WarningSuccess } from "../../static/images/warningIconSuccess.svg";

export const WarningMessage = ({ text = '', isSuccess = false }) => {
    return (
        <WarningMessageContainer isSuccess={isSuccess}>
            <WarningMessageIconContainer>
                {isSuccess ? <WarningSuccess /> : <WarningIcon />}
            </WarningMessageIconContainer>
            <WarningMessageText>{text}</WarningMessageText>
        </WarningMessageContainer>
    )
}